<script lang="ts">
	import { FAQ, FreeQuote } from "#lib/web-ui/home-buyers-template/content/index.js";
	import { getTemplateContext } from "#lib/web-ui/home-buyers-template/template-context.svelte.js";
	const templateContext = getTemplateContext();

	const pageUrl = `${templateContext.siteUrl}faqs/`;
	const pageTitle = `Frequently Asked Questions - ${templateContext.siteName}`;
	const pageDescription = `Get answers to common questions about selling your house fast for cash with ${templateContext.siteName}. Learn about our process, timeline, fees, and programs.`;
</script>

<svelte:head>
	<title>{pageTitle}</title>
	<meta name="description" content={pageDescription} />

	<!-- Open Graph -->
	<meta property="og:type" content="website" />
	<meta property="og:title" content={pageTitle} />
	<meta property="og:description" content={pageDescription} />
	<meta property="og:url" content={pageUrl} />
</svelte:head>

<FreeQuote
	title="We’re Here To Answer Your Questions"
	description="{templateContext.siteName} has purchased thousands of houses and we can buy yours in just a few days. There is no obligation, so contact us today!"
/>
<FAQ />
